import { FileSearch, ListFilter } from 'lucide-react'
import Button from '../../components/ui/button/Button'
import { useBusiness } from '../../context/BusinessContext'

const FilterEmpty = () => {
    const { clearFilters, setOpenFilter } = useBusiness()

    return (
        <div className='space-y-2 w-full h-[70vh] flex flex-col gap-2 items-center justify-center'>
            <FileSearch className='w-44 h-44 text-gray-300 dark:text-gray-700' />
            <p className='text-xl'>Nenhum resultado encontrado!</p>
            <div className='flex items-center gap-4'>
                <Button variant='primary' size='sm' onClick={() => setOpenFilter(true)}>
                    <ListFilter className='w-4 h-4' />
                    <p>Alterar filtros</p>
                </Button>
                <Button variant='link' size='sm' onClick={clearFilters}>
                    <p>Limpar filtros</p>
                </Button>
            </div>
        </div>
    )
}

export default FilterEmpty
